const EN_LOCAL = `en`;
const FR_LOCAL = `fr`;
const AVAILABLE_LOCALS = [EN_LOCAL, FR_LOCAL];
export { EN_LOCAL, FR_LOCAL, AVAILABLE_LOCALS, };
